<template>
  <div class="settings_right">
    <div class="card_section"  >
      <div class="card_section_in">
      <template>
      <stripe-payment @reload="reload" v-if="isPlansLoaded && isExistedPlansLoaded && tenantDetails" @cancelop="cancelop" :tenantDetails="tenantDetails"  :userplan="userplan" :selectedPlan="selectedPlan" :stripe="stripeDataKey" />
      </template>
    </div>
    </div>

    <template v-if="checkProperty(countries, 'length')>0 ">
      <div class="card_section pt-0"  >
            <div class="form_section pt-0">
              <!-- <em class="card_border"></em> -->
                <div class="form-container">
                    
                    <div class="d-flex align-items-center billing_head">
                        <h3 class="small-header pb-4 mb-0">Billing Details</h3>
                        <div class="form_group flex_group nmb-0 pt-6 pl-3" style="align-items:start"  v-if="editBillingInfo">
                            <vs-checkbox @change="updateTenantInfo()" id="bAddress" name="billingadress" v-model="isSameasAdminInformation">Same as Admin Information
                            </vs-checkbox>
                        </div>
                         <div class="biling_edit mt-4" @click="enableBilling();isAddressSame()" v-if="editBillingInfo == false">
                          <svg xmlns="http://www.w3.org/2000/svg" width="17.494" height="17.526" viewBox="0 0 17.494 17.526">
                            <path id="edit" d="M17.494,2.736A2.739,2.739,0,0,0,12.816.8L1.787,11.875A3.282,3.282,0,0,0,1,13.158l-.01.031L0,17.524l4.346-.972.028-.012a3.287,3.287,0,0,0,1.284-.793l11.03-11.08A2.722,2.722,0,0,0,17.494,2.736ZM2.41,15.582l-.461-.461.332-1.458,1.6,1.591ZM15.724,3.708,5.016,14.458l-1.939-1.94,7.334-7.364,1.117,1.117L12.5,5.3,11.371,4.185,12.412,3.14l1.121,1.121.968-.968L13.379,2.17l.4-.4A1.372,1.372,0,1,1,15.72,3.707ZM7.2,16.141h10.3v1.367H5.831Zm0,0" transform="translate(0 0.002)" fill="#48648b"/>
                          </svg>                          
                         </div>
                    </div>
                    <template v-if="editBillingInfo">
                      <div class="vx-row" >
                        <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                                <label class="form_label">Business Name<em>*</em></label> 
                                <vs-input :key="'business name'" autocomplete="off" autocorrect="off" v-validate="'required'" name="business name"
                                v-model="updateTenantData.billingDetails.busName" class="w-full" data-vv-as="Business Name" />
                                <span class="text-danger text-sm" v-if="errors.has('business name')">{{
                                errors.first("business name")
                                }}</span>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                                <label class="form_label">Authorized Person (Name)<em>*</em></label>
                                <vs-input :key="'bilingName'" autocomplete="off" autocorrect="off" v-validate="'required'" name="bilingName"
                                v-model="updateTenantData.billingDetails.authPerson.name" class="w-full" data-vv-as="Name" />
                                <span class="text-danger text-sm" v-if="errors.has('bilingName')">{{
                                errors.first("bilingName")
                                }}</span> 
                            </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                                <label class="form_label">Email<em>*</em></label> 
                                <vs-input :key="'bilingEmail'" autocomplete="off"  autocorrect="off" v-validate="'required|email'" name="bilingEmail"
                                v-model="updateTenantData.billingDetails.authPerson.email" class="w-full" data-vv-as="Email" />
                                <span class="text-danger text-sm" v-if="errors.has('bilingEmail')">{{
                                errors.first("bilingEmail")
                                }}</span> 
                            </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group ph_number">
                            <div class="vs-component">
                            <label class="form_label">Phone Number<em>*</em></label>                            
                            <VuePhoneNumberInput autocomplete="off" autocorrect="off" icon-pack="feather"
                              class="w-full no-icon-border" :no-example="false" v-validate="'required'" name="billPhone"
                              data-vv-as="Phone Number" v-bind="vuePhone.props" :default-country-code="
                              checkProperty(updateTenantData.billingDetails['authPerson']['phoneCountryCode'], 'countryCode')
                              " placeholder="Phone Number" :no-country-selector="false" v-model="updateTenantData.billingDetails.authPerson.phone"
                              @update="updateAuthPersonPhone" :preferred-countries="['US', 'IN']"/>
                          <span class="text-danger text-sm" v-if="!isBillPhoneValid && !errors.has('billPhone')">*Invalid phone number -
                              Please enter a valid one</span>
                          <span class="text-danger text-sm" v-if="errors.has('billPhone')">{{
                              errors.first("billPhone")
                          }}</span>
                            
                          
                            </div>
                        </div>
                        </div>
                      </div>
                      <h3 class="small-header">
                          Address
                      </h3> 
                      <addressFields :showaptType="true" :disableCountry="false" :countries="countries" :validationRequired="true"
                      v-model="updateTenantData['billingDetails']['authPerson']['address']" :cid="'billingaddress'" />
                    </template>
                    
                    <div class="form_details" v-if="!editBillingInfo">
                      <ul>
                        <li v-if="checkProperty(tenantDetails, 'billingDetails', 'busName')">
                          <label>Business Name</label>
                          <p>{{ checkProperty(tenantDetails['billingDetails'], 'busName') }}</p>
                        </li>
                        <li v-if="checkProperty(tenantDetails, 'billingDetails', 'authPerson')&& checkProperty(tenantDetails['billingDetails']['authPerson'], 'name')">
                          <label>Authorized Person (Name)</label>
                          <p>{{ checkProperty(tenantDetails['billingDetails']['authPerson'], 'name') }}</p>
                        </li>
                        <li v-if="checkProperty(tenantDetails, 'billingDetails', 'authPerson') && checkProperty(tenantDetails['billingDetails']['authPerson'], 'email')">
                          <label>Email</label>
                          <p>{{ checkProperty(tenantDetails['billingDetails']['authPerson'], 'email') }}</p>
                        </li>
                        <li v-if="checkProperty(tenantDetails, 'billingDetails', 'authPerson') && checkProperty(tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode', 'countryCallingCode')">
                          <label>Phone Number</label>
                          <p>{{ checkProperty(tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode', 'countryCallingCode')+"&nbsp;" }} {{ checkProperty(tenantDetails['billingDetails']['authPerson'], 'phone')| formatPhone }}</p>
                        </li>
                        <li class="fullwidth" v-if="checkProperty(tenantDetails, 'billingDetails', 'authPerson') && checkProperty(tenantDetails['billingDetails']['authPerson'], 'address')">
                          <label>Address</label>
                          <p v-html="$options.filters.addressformat(tenantDetails['billingDetails']['authPerson']['address'])"></p>
                        </li>
                      </ul> 
                    </div>
                    
                     <!-- <em class="card_border mt-2"></em> -->
                    
                     
                    <div v-if="editBillingInfo" class="form-footer form-footer2 justify-end">
                        <button class="cancel" id="cancel_btn" @click="editBillingInfo = false">Cancel</button>
                        <button class="save" :disabled="formSubmited"  @click="updateTenantProfile()">
                            Update
                        </button>
                    </div>
                    
                </div>
            </div>
            </div>
        </template>




   <template v-if="userplan && ( callFromSerch || list.length>0 )"> 

    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" @input="searchInvoice()" v-model="searchtxt" placeholder="Search by Invoice No"
            class="is-label-placeholder" />
        </div>
      </div>
      <div class="content-header-right">
        <!--filter dropdown-->
      <vs-inv-dropdown >
        <!-- <vs-dropdown  vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content settings_filters"> -->
           <div class="filters-content coltwo">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">

                  
                  <div class="vx-col md:w-1/2 w-full con-select">
                    <label class="typo__label">Select Status</label>
                 
                    <multiselect v-model="selected_statusids" :options="invoice_status" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                      <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template> 
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/2 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                       :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                      :appendToBody="true"
                      :opens="'left'"
                    ></date-range-picker>
                  </div>
                 </div>
                   
                   
     
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons">

              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
      </vs-inv-dropdown>
        <!-- end -->
        <!-- <vs-button type="border" class="light-blue-btn" @click="createNew(true)">Add Card<span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span>
        </vs-button> -->

        
      </div>
    </div>

   
    <!-- <NoDataFound ref="NoDataFoundRef"  v-if="list.length == 0 && !callFromSerch" content="" heading="No Invoice  Found" type='Invoice List' /> -->
    <NoDataFound ref="NoDataFoundRef"  v-if="list.length == 0 && callFromSerch" content="" heading="No Results Found" type='Invoice List' />

    <div class="accordian-table" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <vs-tr>
                            <vs-th class="text-left">
                                <span @click="sortMe('refId')" v-bind:class="{
                      sort_ascending: sortKeys['refId'] == 1,
                      sort_descending: sortKeys['refId'] != 1,
                    }">Invoice No. 
                                </span>
                            </vs-th>

                            

                        <vs-th class="text-left" v-if="userRole && [1,2,3].indexOf(userRole)>-1" >
                                   <!-- <span @click="sortMe('email')" v-bind:class="{
                            sort_ascending: sortKeys['email'] == 1,
                            sort_descending: sortKeys['email'] != 1,
                        }">Email
                                    </span>
                                    refId
                                    -->
                                    Email
                                </vs-th>

                            <vs-th class="text-left">Plan</vs-th>
                            <vs-th>
                                <span @click="sortMe('totalAmount')" v-bind:class="{
                      sort_ascending: sortKeys['totalAmount'] == 1,
                      sort_descending: sortKeys['totalAmount'] != 1,
                    }">Amount($)
                                </span>
                            </vs-th>
                            <vs-th>
                                <span @click="sortMe('createdOn')" v-bind:class="{
                      sort_ascending: sortKeys['createdOn'] == 1,
                      sort_descending: sortKeys['createdOn'] != 1,
                    }">Created On
                                </span>
                            </vs-th>
                            <vs-th>Status</vs-th>
                            <vs-th></vs-th>
                        </vs-tr>
         <template v-if="list.length > 0">
                            <template v-for="(payment, index) in list">
                                <vs-tr :key="index">
                                    <vs-td>{{payment.refId}}</vs-td>
                                    <vs-td class="text-left" v-if="userRole && [1,2,3].indexOf(userRole)>-1" >
                                        {{checkProperty(payment , 'subscriberDetails' ,'email') }}
                                    </vs-td>
                                    <vs-td>
                                      <span v-if="payment.planDetails && payment.planDetails.name">{{ payment.planDetails.name }}
                                      </span>
                                      <template v-if="false">
                                        <span v-if="payment.planDetails.criteria && payment.planDetails.criteria.length > 0 && payment.planDetails.criteria[0].qty!=0">{{payment.planDetails.criteria[0].qty}} </span>
                                        <span v-if="payment.planDetails.criteria && payment.planDetails.criteria.length > 0 && payment.planDetails.criteria[0].label!=null">{{payment.planDetails.criteria[0].label}}</span>
                                   
                                      </template>
                                    </vs-td>
                                    <vs-td>${{payment.totalAmount}}</vs-td>
                                    <vs-td>{{payment.createdOn | formatDate}}</vs-td>
                                    <vs-td>
                                        <div class="d-flex align-items-center">
                                            <span class="td_status " :class="{'pending':payment.statusId==1,'paid':payment.statusId==2}">{{ checkProperty(payment ,'statusDetails' , 'name') }}</span>

                                        </div>
                                    </vs-td>
                                    <vs-td>
                                      <div class="action-icons">
                                        <a class="download IB_tooltip"  @click="downloadInvoice(payment)">
                                          <div class="tooltip_cnt">
                                            <p> Download </p>
                                          </div>
                                        </a>
                                      </div>
                                        <div class="menu_profile" v-if="false">
                                            <v-icon>mdi-dots-horizontal</v-icon>
                                            <div class="menu_list">
                                                <ul>
                                                    <li @click="downloadInvoice(payment)"><a>Download</a></li>
                                                    <!-- <li><a href="#">View</a></li>-->
                                                </ul>
                                            </div>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </template>
      </vs-table>
      <paginate  v-if="list.length>0"  v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2" :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
        :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
    </div>
  </template>


    

  
  </div>
</template>

<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import Paginate from "vuejs-paginate";
  import NoDataFound from "@/views/common/noData.vue";
  
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

  import _ from "lodash";
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
   import moment from 'moment'
  import PhoneMaskInput from "vue-phone-mask-input";
  import JQuery from 'jquery'
  import { TheMask } from 'vue-the-mask'
  
import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { MoreVerticalIcon } from 'vue-feather-icons';
import stripePayment from "@/views/subscription/stripe.vue";
import addressFields from "@/views/forms/fields/address.vue";
  export default {
    provide() {
    return {
      parentValidator: this.$validator,
    };
  },
    computed:{
     
    },
    components: {
      vsInvDropdown,
      stripePayment,
      NoDataFound,
      DateRangePicker,
      VuePhoneNumberInput,
      Datepicker,
      Paginate,
      FileUpload,
      FormWizard,
      TabContent,
      PhoneMaskInput,
      TheMask,
      MoreVerticalIcon,
        addressFields
    },

    data: () => ({
      editBillingInfo:false,
      countries: [],
            vuePhone: {
                props: {
                    translations: {
                        phoneNumberLabel: "Phone Number",
                    },
                },
            },
            isSameasAdminInformation:false,
            isBillPhoneValid:true,
            updateTenantData:{
                billingDetails:{
                    busName:'',
                    authPerson:{
                        name:'',
                        email:'',
                        phone:'',
                        phoneCountryCode:{
                        countryCode:'IN',
                        countryCallingCode:'91'
                        },
                        address: {
                        line1: "",
                        line2: "",
                        countryId: '',
                        countryDetails: null,
                        stateId: "",
                        locationId: "",
                        zipcode: "",

                        stateDetails: null,
                        locationDetails: null,
                        aptType: '',
                    },
            
                 },

              },
            },
            tenantDetails:null,
      stripeDataKey:'',
      invoice_status:[],
        selectedPlan:null,
        isPlansLoaded:false,
        isExistedPlansLoaded:false,
         cardDetails: null,
         activeCardInfo:null,
        userplan:null,
        updatecard:false,
       
         newform: {name:'' ,type:'' , description:'',"document":null , attachments:[],"today":moment().format("YYYY-MM-DD")},
        edit:false,
        addPopup:false,
      callFromSerch:false,
      formSubmited:false, 
      uploading:false,
     
    selected_createdDateRange: ["", ""],
    autoApply: "",
        value:[],
        all_formTypes:[{"name":"Form" ,"id":"Form"},{"name":"Letter" ,"id":"Letter"} ],
        
    
      formerrors: {
        msg: ""
      },
      date: null,
      
      list: [],
      searchtxt: "",
      
      all_statusids: [],
      selected_statusids: [],
      date_range: [],
      page: 1,
      perpage: 25,
      totalpages: 0,
      

     
      switch2:true,
      users_status:{},
      edit:false,
      sortKeys:{},
      sortKey:{},
      planslist:[],
      invoice_company_list:[],
      callFromSort:false,
      dateRange:[],
     loading:false,
     debounce:null
    }),
    watch: {
      // searchtxt: function (value) {
      //   this.getList(true);
      // }

    },
    methods: {
      downloadInvoice(pay){ //  this.$globalgonfig._BASEURL
        let webBaseUrl = window.location.origin;
        let cardBaseUrl = window.location.origin
        if(webBaseUrl.includes('localhost') || webBaseUrl.includes('anyclap') || webBaseUrl.includes('192') ){
            cardBaseUrl = 'https://anyclap.com'
        }
        window.open(cardBaseUrl+"/paymentsbeta/common/viewfile?path=" +this.checkProperty(pay, 'document'),"_blank");
      },
      searchInvoice(){
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          this.callFromSerch = true;
          this.getList(true);
        }, 500)
      },
      updateTenantProfile(){
            this.$validator.validateAll().then((result) => {
                if(result){
                  let postData =  _.cloneDeep(this.updateTenantData);
                  let path = '/tenant/update-billing-details'
                  this.$vs.loading();
                  this.formSubmited = true;
                  this.$store.dispatch("commonAction", {'data':postData, 'path':path}).then((response)=>{
                    this.editBillingInfo = false
                    let pyld = _.cloneDeep(postData);
                    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                    pyld = Object.assign(pyld, {
                      'email':this.checkProperty(this.tenantDetails, 'adminEmail'),
                      timezone: timezone,
                      browserTS: moment(new Date()),
                      today: moment(new Date()).format("YYYY-MM-DD")
                    });
                    this.$store.dispatch("subscription/subscriberBilling", pyld).then((res) => {

                    }).catch((err)=>{})


                    this.showToster({ message: response.message, isError: false });
                    this.getTenantDetails(true);
                    this.$vs.loading.close();
                    this.formSubmited = false;
                  }).catch((error)=>{
                    this.$vs.loading.close();
                    this.formSubmited = false;
                    this.showToster({ message: error, isError: true });
                  })
                }else {
                  this.$vs.loading.close();
                  this.scrollWIndow();
              } 
            })
      },
      scrollWIndow() {
      const $ = JQuery;

      $("html, body").animate(
        {
          scrollTop: $(".text-danger").first().offset().top,
        },
        2000
      );
     
    },
      getTenantInformation(){
        if(_.has(this.tenantDetails,'billingDetails')){
          if(_.has(this.tenantDetails['billingDetails'], 'busName')){

              this.updateTenantData['billingDetails']['busName'] = this.tenantDetails['billingDetails']['busName']
          }

          if(_.has(this.tenantDetails['billingDetails'], 'authPerson')){
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'name')){

                  this.updateTenantData['billingDetails']['authPerson']['name'] = this.tenantDetails['billingDetails']['authPerson']['name']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'email')){
                  this.updateTenantData['billingDetails']['authPerson']['email'] = this.tenantDetails['billingDetails']['authPerson']['email']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'],'phone')){
                  this.updateTenantData['billingDetails']['authPerson']['phone'] =  this.tenantDetails['billingDetails']['authPerson']['phone']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode')){
              if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCode')){
                this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCode']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCallingCode')){
                  this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode']
              }
              if (_.has(this.tenantDetails['billingDetails']['authPerson'], "address")) {
              let dt = this.tenantDetails['billingDetails']['authPerson']['address']
              this.updateTenantData['billingDetails']['authPerson']["address"] = _.cloneDeep(dt);
              }
            }

          }




        }

      },
      isAddressSame(callFromMount=false) {
        if(_.has(this.tenantDetails,'billingDetails') && _.has(this.tenantDetails['billingDetails'], 'busName') && this.checkProperty(this.tenantDetails['billingDetails'], 'busName')){
          if(_.has(this.tenantDetails['billingDetails'], 'busName')){
            this.updateTenantData['billingDetails']['busName'] = this.tenantDetails['billingDetails']['busName']
          }
          if(_.has(this.tenantDetails['billingDetails'], 'authPerson')){
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'name')){
                this.updateTenantData['billingDetails']['authPerson']['name'] = this.tenantDetails['billingDetails']['authPerson']['name']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'email')){
                this.updateTenantData['billingDetails']['authPerson']['email'] = this.tenantDetails['billingDetails']['authPerson']['email']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'],'phone')){
                this.updateTenantData['billingDetails']['authPerson']['phone'] =  this.tenantDetails['billingDetails']['authPerson']['phone']
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode')){
                if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCode')){
                  this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCode']
                }
                if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCallingCode')){
                  this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode']
                }
              }
              if (_.has(this.tenantDetails['billingDetails']['authPerson'], "address")) {
                let dt = this.tenantDetails['billingDetails']['authPerson']['address']
                this.updateTenantData['billingDetails']['authPerson']["address"] = _.cloneDeep(dt);
              }

          }
        }else{
          this.editBillingInfo = true
        }
      },
      enableBilling(){
        this.editBillingInfo = true;
        this.isSameasAdminInformation = false
      },
      updateTenantInfo() {
        if(this.isSameasAdminInformation){
          if(_.has(this.tenantDetails,'name') && this.checkProperty(this.tenantDetails, 'name')){
            this.updateTenantData['billingDetails']['busName'] = this.tenantDetails['name']
          }
          if(_.has(this.tenantDetails,'adminName') && this.checkProperty(this.tenantDetails, 'adminName')){
            this.updateTenantData['billingDetails']['authPerson']['name'] =  this.tenantDetails['adminName']
          }
          if(_.has(this.tenantDetails,'adminEmail') && this.checkProperty(this.tenantDetails, 'adminEmail')){
            this.updateTenantData['billingDetails']['authPerson']['email'] =  this.tenantDetails['adminEmail']
          }
          if(_.has(this.tenantDetails,'phone') && this.checkProperty(this.tenantDetails, 'phone')){
            this.updateTenantData['billingDetails']['authPerson']['phone'] =  this.tenantDetails['phone']
            if(_.has(this.tenantDetails,'phone') && this.checkProperty(this.tenantDetails, 'phoneCountryCode')){
              if(_.has(this.tenantDetails,'phoneCountryCode') && this.checkProperty(this.tenantDetails, 'phoneCountryCode', 'countryCode')){
                this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] =  this.tenantDetails['phoneCountryCode']['countryCode']
              }
              if(_.has(this.tenantDetails,'phoneCountryCode') && this.checkProperty(this.tenantDetails, 'phoneCountryCode', 'countryCallingCode')){
                this.updateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] =  this.tenantDetails['phoneCountryCode']['countryCallingCode']
              }
            }
          }
          if(_.has(this.tenantDetails,'adminEmail') && this.checkProperty(this.tenantDetails, 'adminEmail')){
            this.updateTenantData['billingDetails']['authPerson']['email'] =  this.tenantDetails['adminEmail']
          }
          if(_.has(this.tenantDetails,'address') && this.checkProperty(this.tenantDetails, 'address')){
            let dt = this.tenantDetails['address']
            this.updateTenantData['billingDetails']['authPerson']['address'] =  _.cloneDeep(dt);
          }
        }
        // else if(_.has(this.tenantDetails, 'billingDetails') && _.has(this.tenantDetails['billingDetails'], 'busName') && this.checkProperty(this.tenantDetails['billingDetails'], 'busName')){
        //   this.isAddressSame()
        // }
        else{
          this.updateTenantData = {
                billingDetails:{
                    busName:'',
                    authPerson:{
                        name:'',
                        email:'',
                        phone:'',
                        phoneCountryCode:{
                        countryCode:'IN',
                        countryCallingCode:'91'
                        },
                        address: {
                        line1: "",
                        line2: "",
                        countryId: '',
                        countryDetails: null,
                        stateId: "",
                        locationId: "",
                        zipcode: "",

                        stateDetails: null,
                        locationDetails: null,
                        aptType: '',
                    },
            
                 },

              },
            }
        }
      },
      updateAuthPersonPhone(item){
    this.isBillPhoneValid = true
    if(item.isValid){
      this.updateTenantData['billingDetails']['authPerson'].phoneCountryCode = {countryCode:item.countryCode, countryCallingCode: item.countryCallingCode}
      this.updateTenantData['billingDetails']['authPerson'].phone = item.nationalNumber
    }else{
      this.isBillPhoneValid = false
    }

      },
      getTenantDetails(callFromMount=false) {
          let postData = {
              tenantId: this.getUserData["tenantDetails"]["_id"],
          };
          this.$store.dispatch("get_tenant_details", postData).then((response) => {
              this.tenantDetails = response;
              if(callFromMount){
                  this.isAddressSame(callFromMount)
              }
              
          }).catch((error) => {
              
          });
      },
      getplans() {
          let payLoad = {
              page: 1,
              perpage: 2500,
              today: moment(new Date()).format("YYYY-MM-DD"),
          };
            this.isPlansLoaded =false;
    
          this.$store.dispatch("subscription/getplans", payLoad).then((res) => {
              this.isPlansLoaded =true;

              this.planslist = res.list;
              if(this.checkProperty(this.planslist ,'length') >0){
                  this.selectedPlan = this.planslist[0];
                  
              }
              

          }).catch((err)=>{
              this.isPlansLoaded =true;
          })

      },
      cancelop(action=false) {
          
          this.addPopup = false;
      },
      getCardDetails() {
          //cardDetails
          this.activeCardInfo =null
          this.updatecard =false;
          var user = this.$store.state.user;
          let self =this; 

          let tenantDetails = self.checkProperty(user , "tenantDetails")
            let subscriber = {
                  name: self.checkProperty(tenantDetails , "adminName"),
                  email: self.checkProperty(tenantDetails , "adminEmail"),
                  phone: self.checkProperty(user , "phone"),
                  phoneCode: self.checkProperty(user , "phoneCountryCode" ,"countryCallingCode")
              } 
          var payLoad = {
              subscriber: subscriber,
              page: 1,
              perpage: 100,
              appActivity: true
          };
          this.$store.dispatch("subscription/cardDetails", payLoad).then((cardResponse) => {
              self.cardDetails = cardResponse.list;

              if(self.checkProperty( self.cardDetails ,"length") >0){
                  let latestCard = self.cardDetails[0];
                    if(self.checkProperty( latestCard ,"source" ,"card")){
                      self.activeCardInfo = latestCard['source']['card'];
                      self.updatecard  =true;
                    }
                    
                }
            
          })
      },
      createNew(action=false){
            this.newform=  {name:'' ,type:'' , description:'',"document":null , attachments:[],"today":moment().format("YYYY-MM-DD")},
            this.addPopup = action

      },
      set_filter: function () {
        this.callFromSerch = true;
        // this.$refs["filter_menu"].dropdownVisible = false;
        document.body.classList.remove('scroll-hidden');
        this.getList(true);
      },
      clear_filter: function () {
        this.searchtxt ='';
        this.callFromSerch =true;
        // this.$refs["filter_menu"].dropdownVisible = false;
        document.body.classList.remove('scroll-hidden');
        this.selected_statusids = [];
     
        this.date = "";
        this.date_range = [];
         this.selected_createdDateRange["startDate"] = "";
         this.selected_createdDateRange["endDate"] = "";
        this.getList();
      },
      pageNate(pageNum) {
        this.page = pageNum;
        this.getList();
      },
      getMaterData(category ='invoice_company_list') {
            let payLoad = {
                appActivity: true,
                matcher: {
                    title: "",
                    cntryIds: [],
                    stateIds: [],
                },
                category: category ,//"invoice_company_list", // "plan_type", //invoice_company_list, city, state, country, plan_category, plan_frequency, plan_operator, payment_service, plan_status, subscribe_status, invoice_status, user_role, user_status, company_status
                page: 1,
                perpage: 2500,
            };
            this.$store.dispatch("subscription/getMaterData", payLoad).then((res) => {
                this[category] = res.list;
               
            });
      },
      getList() {
            var self = this;
                let user = this.$store.state.user;
             let userRole = this.$store.state.userRole;
             //adminEmail
             let tenantDetails = self.checkProperty(user , "tenantDetails")
             let subscriber = {
                    name: self.checkProperty(tenantDetails , "adminName"),
                    email: self.checkProperty(tenantDetails , "adminEmail"),
                    phone: self.checkProperty(tenantDetails , "phone"),
                    phoneCode: self.checkProperty(tenantDetails , "phoneCountryCode" ,"countryCallingCode")
                }

            let obj = {
                appActivity: true,
                "filters": {
                    "companyId": "", // Send When view as 'Admin'
                    "title": this.searchtxt,
                    "statusIds": [],
                    "dueDateRange": [],
                    "paidDateRange": [],
                    "createdOnRange": []
                },
                page: this.page,
                perpage: this.perpage,
                //sortKeys: this.sortKey,
                sorting: this.sortKey
            };

            

            if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
       obj["filters"]["createdOnRange"]= [
          moment(this.selected_createdDateRange["startDate"]).format("YYYY-MM-DD"),
          moment(this.selected_createdDateRange["endDate"]).format("YYYY-MM-DD")
        ];
      }

          // if ([1, 2, 3].indexOf(userRole) != -1) {

          //           obj["filters"]["companyId"] = this.invoice_company_list[0]['_id'];

          //       } else {
          //           obj["subscriber"] = subscriber

          //       }
           obj["subscriber"] = subscriber

            if (this.callFromSort) {
                this.callFromSort = false;
            } else {
                this.loading = true;
                this.callFromSort = false;
                this.list = [];

            }
          obj['filters']['statusIds'] =   this.selected_statusids.map((item)=>item._id)
          self.updateLoading(true);
            this.$store
                .dispatch("subscription/getList", {
                    data: obj,
                    path: "/invoices/list"
                })
                .then((response) => {
                    // alert(JSON.stringify(response));
                    this.list = response.list;
                    this.totalpages = Math.ceil(response.totalCount / this.perpage);
                   // this.totalpages = Math.ceil(response.totalCount / this.perpage);

                 
                
                   setTimeout(() => {
                       self.updateLoading(false);

                            setTimeout(() => {
                            self.updateLoading(false);
                        } ,10)
                   } ,10)
                })
                .catch((err) => {
                    //alert(err);
                    this.list = [];
                    setTimeout(() => {
                       self.updateLoading(false);
                   } ,10)
                });
      },
      getCurrentPlan(){
          this.userplan= null;
            var user = this.getUserData
            let self = this;
            let tenantDetails = self.checkProperty(user , "tenantDetails")
            let subscriber = {
                  name: self.checkProperty(tenantDetails , "adminName"),
                  email: self.checkProperty(tenantDetails , "adminEmail"),
                  phone: self.checkProperty(tenantDetails , "phone"),
                  phoneCode: self.checkProperty(tenantDetails , "phoneCountryCode" ,"countryCallingCode")
              }
            
          var payLoad = {
                  selPlanIds: [],
                  plans: [],
                  source: null,
                  serviceTypeId: 1,
                  methodTypeId: 1,
                  newSource: true,
                  subscriber: subscriber,
                  today: moment(new Date()).format("YYYY-MM-DD"),
                  timezone: moment.tz.guess(),
                  browserTS: moment(new Date())
              };
                var chargepayload = payLoad;
                this.isExistedPlansLoaded =false;
              this.$store.dispatch("subscription/getSelectedPlan", payLoad).then((currentPlan) => {
                  this.isExistedPlansLoaded =true;
                  if (currentPlan && this.checkProperty(currentPlan , 'length') >0 ) {
                      this.userplan=currentPlan[0];
                      this.$store.commit("subscription/updateCurrentPlan" ,this.userplan)
                      

                  }
              }).catch((err) => {
                  this.isExistedPlansLoaded =true;

              })    
            
      },
      init(){
        this.isPlansLoaded =false;
        this.isExistedPlansLoaded =false;

        //this.$store.dispatch("updateSidebarWidth", "extended");
      this.getplans();
    this.getCurrentPlan();
    this.getCardDetails();
    
    this.getMaterData('invoice_status');
    this.getMaterData('invoice_company_list');
    
    this.selected_statusids = [];
      this.sortKeys = {
          'name':1,
          'typeName':1,
          'statusName':1,
          "createdOn":-1,
          "updatedOn":1
    
  },
  //invoice_status

  this.sortKey = {"path":"createdOn" ,"order":-1};
  this.getList();
    

      },
      reload(){
      
        // this.init();
        this.isPlansLoaded =false;
        this.isExistedPlansLoaded =false;
          this.getCurrentPlan();
          this.getCardDetails();
        setTimeout(() => {
            this.isPlansLoaded =true;
            this.isExistedPlansLoaded =true;
            this.$store.dispatch("common/activateSettingTab", 'profile');
            this.$emit('startTour')
        } ,10)
      }
    },
    mounted() {
      this.getTenantDetails(true)
      this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;
            });
      if(this.isProductionEnv()){
        this.stripeDataKey = this.$globalgonfig.STRIPKEY
      }else{
        this.stripeDataKey = this.$globalgonfig._ANYCALP_STRIPKEY
      }
      this.init();

      
    }
  };
</script>
